import React from 'react';
import { useApi } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { TaxonomyApi } from '../../api/taxonomy-api';
import { CandidateExperienceApi } from '../../api/candidate-experience-api';
import { CandidateProfileIssuesApi } from '../../api/candidate-profile-issues-api';
import { ExperienceUtil } from '../../utils/experience-util';

import { ExperiencesCard } from './ExperiencesCard';

export const Experiences = ({
  candidateId,
  name = 'EXPERIENCES',
}: {
  candidateId: Candidate['id'];
  name?: string;
}) => {
  const [{ data: taxonomy }, { data: experiences }, { data: profileIssues }] =
    useApi(
      TaxonomyApi.readTaxonomy(),
      CandidateExperienceApi.readExperiences(candidateId),
      CandidateProfileIssuesApi.readCandidateProfileIssues(candidateId)
    );

  const orderedExperiences =
    ExperienceUtil.orderExperiencesForDisplay(experiences);

  return (
    <ExperiencesCard
      name={name}
      experiences={orderedExperiences}
      taxonomy={taxonomy}
      candidateId={candidateId}
      issues={profileIssues.issues}
    />
  );
};
